import { ability, ACTIONS, SUBJECTS } from '../../../../Permission'
import { CreateHSForm } from './CreateHSForm'
import { ViewHS } from './ViewHS'
import { useHSDetailsContext } from '../Providers/HSContextProvider'
import { useSelector } from 'react-redux'
import { getUser } from '../../../../../redux/store/user/getters'

export const GeneralDetails = () => {
  const {
    state: { details }
  } = useHSDetailsContext()

  const user = useSelector(getUser)

  const canEditHS =
    ability.can(ACTIONS.CRUD, SUBJECTS.HEALTH_SYSTEM) ||
    (ability.can(ACTIONS.EDIT, SUBJECTS.HEALTH_SYSTEM) &&
      details?.uuid === user.health_system)

  if (canEditHS) return <CreateHSForm />
  return <ViewHS />
}
